<div class="style-editor-wrapper">
  <button mat-icon-button
          color="accent"
          [disabled]="false"
          [style.color]="style.color ?? defaultStyle.color"
          [matMenuTriggerFor]="lineStyleEditor">
    <div class="line-type-wrapper">
      <app-line-dash-array-view
        [dashArray]="style.lineType"
        [color]="style.color ?? defaultStyle.color"
      ></app-line-dash-array-view>
    </div>
  </button>

  <mat-menu #lineStyleEditor="matMenu">
    <div class="px-10">
      <span [style.background]="style.color"
            [cpToggle]="true"
            [cpDialogDisplay]="'inline'"
            [cpAlphaChannel]="'disabled'"
            [(colorPicker)]="style.color"
            (colorPickerChange)="styleChanged()"
      ></span>

      @if(defaultStyle && style.color) {
        <button
          (click)="clearColor(); $event.stopPropagation()"
          [matTooltip]="'Reset color to default'"
          mat-button
          class="w-100"
        >
          <mat-icon>format_color_reset</mat-icon>
          Reset Color to Default
        </button>
      }

      <div class="pt-15">
        @if (editWidth) {
          <mat-form-field class="no-hint w-100">
            <mat-label>Route Width</mat-label>
            <input matInput
                   type="number"
                   min="0"
                   [(ngModel)]="style.width"
                   (click)="$event.stopPropagation()"
                   (change)="styleChanged()">
          </mat-form-field>

          @if(defaultStyle && style.width) {
            <button
              (click)="clearWidth(); $event.stopPropagation()"
              [matTooltip]="'Reset width to default'"
              mat-button
              class="w-100 mb-15"
            >
              <mat-icon>measuring_tape</mat-icon>
              Reset Width to Default
            </button>
          }
        }

        @if (editOpacity) {
          <mat-form-field class="no-hint w-100">
            <mat-label>Route Opacity</mat-label>
            <input matInput
                   type="number"
                   max="1"
                   min="0"
                   [matTooltip]="'Decimal value 0.0 - 1.0'"
                   [(ngModel)]="style.opacity"
                   (click)="$event.stopPropagation()"
                   (change)="styleChanged()">
          </mat-form-field>

          @if(defaultStyle && style.opacity) {
            <button
              (click)="clearOpacity(); $event.stopPropagation()"
              [matTooltip]="'Reset opacity to default'"
              mat-button
              class="w-100 mb-15"
            >
              <mat-icon>opacity</mat-icon>
              Reset Opacity to Default
            </button>
          }
        }

        <app-line-type-selector
          class="line-type-selector"
          [(dashArray)]="style.lineType"
          (click)="$event.stopPropagation()"
          (dashArrayChange)="styleChanged()"
        >
        </app-line-type-selector>

        @if (defaultStyle && style.lineType) {
          <button
            mat-button
            (click)="clearDashArray(); $event.stopPropagation()"
            [matTooltip]="'Reset to default'"
            class="w-100"
          >
            <mat-icon>restart_alt</mat-icon>
            Reset Line Type to Default
          </button>
        }
      </div>
    </div>
  </mat-menu>

  <!-- preview -->
    <!--<div
       [style.width]="'80px'"
       [style.opacity]="routeStyle?.opacity"
       [style.height]="routeStyle?.width + 'px'"
       [style.background-color]="routeStyle?.color"
    ></div>-->

</div>
